import React, { useState } from 'react';
import { HeadLine } from '../../layouts/headers/HeadLine';
import CSS from 'csstype';
import { ToursCardList } from './components/ToursCardList';
import './Style.css';
import { MainService } from '../../controllers/MainService';

export const ToursMainPage = () => {

  const [scrollpos, setScrollpos] = useState(316);

  const tours = MainService.getTours();

  const handleScroll = (e) => {

    if (e.target.scrollTop > 0) {
      setScrollpos(137);
    } else {
      setScrollpos(316);
    }

  }

  const bgimage: CSS.Properties = { background: "linear-gradient(180deg, rgba(0, 0, 0, 0.6) 0%, rgba(0, 0, 0, 0.3) 100%), url('/assets/img/tours_1.png') no-repeat center center / cover" };

  return (

    <>
      <div className='w-full absolute z-1 head-hi-sm flex flex-col justify-center'>
        <HeadLine title='Tours & Excursiones' backurl='/' />
      </div>

      <div className="w-full relative content-hi-sm">
        <div className="flex justify-center items-center" style={msgWarnStyle}>
          <span >El cobro del servicio se realizará a tu tarjeta de crédito registrada</span>
        </div>
        <div className="bg_room_page flex justify-center items-center bg_page_top" style={bgimage}>
          <img src="/assets/img/icons/tours-icon.svg" alt="Icono room" width={'64px'} />
        </div>
      </div>

      <div className="absolute z-1 w-full border shadow detail-experience-container pb-4 bg_page_top"
        onScroll={handleScroll} style={{ height: `calc(100% - ${scrollpos}px)` }}>

        <div className='txt_s3 text-center mt- mb-4'>Tours cercanos a la ubicación del hotel</div>

        <ToursCardList items={tours}  />
      </div>
    </>

  );
};

export const msgWarnStyle: CSS.Properties = {
  color: '#012349',
  height: '60px',
  fontSize: '14px',
  backgroundColor: '#FFE36F',
  width: '100vw',
  paddingRight: '50px',
  paddingLeft: '50px',
  marginLeft: '-14px',
  marginTop: '-14px',
  marginBottom: '14px',
  fontWeight: '600',
  lineHeight: '14px',
  textAlign: 'center'
}